import { CategoryDownloadDto } from 'collaboration-service';
import * as React from 'react';
import { BaseEditItem, useSelectorGPE } from '../GeneralPostEdit';
import { useGPEState } from '../Helpers/UseGPEState';
import * as _ from "lodash";
import { getTranslated } from 'services/Helpers/TranslationHelpers';
import { ImgSelect } from 'imaginarity-react-ui';
import { GeneralPostEditState } from '../GeneralPostEditStateHandling';
import { PostEditElementProps } from '../TypeImplementations/PostEdit';

interface EditCategoryLikeMultipleProps<T, S> extends PostEditElementProps<T, S> {
    toSelect: keyof GeneralPostEditState;
    filterByCategoryType?: string;
}
const EditCategoryLikeMultiple = <T extends BaseEditItem = BaseEditItem>(p: EditCategoryLikeMultipleProps<T, CategoryDownloadDto[]>) => {
    const { filterByCategoryType } = p;
    const { value: val, setValue: setVal } = useGPEState(p.getter);
    const [opt, setOpt] = React.useState<Array<{ label: string, value: string }>>();
    const categories = useSelectorGPE(s => (s as any)[p.toSelect] as CategoryDownloadDto[]);

    const chg = React.useMemo(() => (val: ReadonlyArray<{ label: string, value: string }>) => {
        const vals = _.filter(categories, c => _.find(val, v => v.value === c.id) !== undefined);
        setVal(vals);
    }, [categories, setVal]);

    React.useEffect(() => {
        let filteredCategories = categories;
        if (filterByCategoryType)
            filteredCategories = _.filter(categories, c => c.categoryType === filterByCategoryType);
        setOpt(_.map(filteredCategories, c => ({ value: c.id, label: getTranslated(c.names).text })))
    }, [categories, filterByCategoryType])

    if (!opt)
        return <div />;

    const selVal = _.filter(opt, o => _.find(val, v => v.id === o.value) !== undefined);
    return (
        <ImgSelect
            options={opt}
            value={selVal}
            onChange={chg}
            isMulti
        />
    );
}
export default EditCategoryLikeMultiple;